import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @fileoverview Defines a React Context for handling PDF-specific text selection events.
 * This context decouples the component that triggers the selection event from the
 * component that manages the application's state in response to that selection.
 */
import React, { createContext, useContext } from 'react';
const PdfSelectionEventContext = createContext(undefined);
/**
 * A provider component that makes the PDF selection event handler available
 * to any descendant components.
 */
export const PdfSelectionEventContextProvider = ({ children, onSelectionChange, }) => {
    const contextValue = React.useMemo(() => ({ onSelectionChange }), [onSelectionChange]);
    return (_jsx(PdfSelectionEventContext.Provider, { value: contextValue, children: children }));
};
/**
 * A hook for consuming the PDF selection event handler.
 * It ensures that it's used within a valid provider context.
 */
export const usePdfSelectionEventHandler = () => {
    const context = useContext(PdfSelectionEventContext);
    if (context === undefined) {
        throw new Error('usePdfSelectionEventHandler must be used within a PdfSelectionEventContextProvider');
    }
    return context;
};
//# sourceMappingURL=PdfSelectionEventContext.js.map